import React from "react"
import { useConsentDialogTrigger } from "@c15t/react"
import CookieSettingsLink from "cookiesConsent/features/reopenConsent/CookieSettingsLink"

interface C15tCookieSettingsLinkProps {
  className?: string
}

const C15tCookieSettingsLink = ({ className }: C15tCookieSettingsLinkProps) => {
  const { openDialog } = useConsentDialogTrigger({ showWhen: `always` })

  return <CookieSettingsLink onReopen={openDialog} className={className} />
}

export default C15tCookieSettingsLink
